// ConnectionLockContext — 「再接続中は描けない」(docs/_wip/reconnect-draw-lock-2026-10-12.md)
// の単一 boolean を配る薄い context。
//
// `locked` = `view.phase.t === 'reconnecting'` (= WS が open でない)。SessionProvider が
// 値を供給する。Provider の外 (= 単体テスト等) では既定値 `locked:false` になるので、
// 既存の描画系コンポーネントは Provider 無しでもそのまま動く。

import { createContext, useContext } from 'react';

export interface ConnectionLockValue {
  /** true の間、サーバに送る操作 (描画 / 全消し / Undo / 背景色 / 画像貼り付け / チャット送信) を受け付けない。 */
  readonly locked: boolean;
  /**
   * true = WS は復帰済みだが、再接続後の snapshot 適用がまだ終わっていない (locked も true)。
   * 描画は塞ぐが「再接続中」の帯は出さない (ReconnectOverlay が無視する)。
   */
  readonly hydrating?: boolean;
  /** 再接続の試行回数 (1 始まり)。locked=false のときは 0。 */
  readonly attempt: number;
  /** 試行回数の上限 (表示用「(n/20)」の分母)。 */
  readonly maxAttempts: number;
}

export const UNLOCKED: ConnectionLockValue = { locked: false, attempt: 0, maxAttempts: 0 };

export const ConnectionLockContext = createContext<ConnectionLockValue>(UNLOCKED);

export const useConnectionLock = (): ConnectionLockValue => useContext(ConnectionLockContext);

/** 「いま送る操作を止めるべきか」だけが欲しい呼び出し側用。 */
export const useConnectionLocked = (): boolean => useContext(ConnectionLockContext).locked;
